import PropTypes from 'prop-types';

export const userShape = PropTypes.shape({
  email: PropTypes.string,
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  role: PropTypes.string,
});

export const remoteStreamShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  user: userShape,
  token: PropTypes.string.isRequired,
});

export const broadcastStreamShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  description: PropTypes.string,
  hash: PropTypes.string,
  isStream: PropTypes.bool,
  name: PropTypes.string.isRequired,
  remoteStream: remoteStreamShape.isRequired,
  user: userShape.isRequired,
});

export const broadcastItemShape = PropTypes.shape({
  comments: PropTypes.bool.isRequired,
  createdAt: PropTypes.number.isRequired,
  hash: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  remoteStream: remoteStreamShape.isRequired,
  user: userShape.isRequired,
});

export const broadcastsDataShape = PropTypes.shape({
  error: PropTypes.bool.isRequired,
  list: PropTypes.arrayOf(broadcastItemShape).isRequired,
  loading: PropTypes.bool.isRequired,
  noBroadcasts: PropTypes.bool.isRequired,
});

export const channelItemShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export const heroStreamShape = PropTypes.shape({
  broadcast: broadcastStreamShape,
  description: PropTypes.string,
  durationSeconds: PropTypes.number,
  id: PropTypes.number.isRequired,
  m3u8Url: PropTypes.string,
  outfile: PropTypes.string,
  remoteStream: remoteStreamShape.isRequired,
  renderStatus: PropTypes.string,
  startedAt: PropTypes.number.isRequired,
  stoppedAt: PropTypes.number.isRequired,
  streamCode: PropTypes.string.isRequired,
  streamName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
  user: userShape.isRequired,
});

export const routerHistoryShape = PropTypes.shape({
  push: PropTypes.func.isRequired,
});

export const routerLocationShape = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
});

export const routerMatchShape = PropTypes.shape({
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object.isRequired,
});

export const ConnectionNetworkShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string.isRequired,
  isSupported: PropTypes.bool.isRequired,
});

export const ConnectionItemShape = PropTypes.shape({
  id: PropTypes.string,
  network: ConnectionNetworkShape.isRequired,
  apiKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  hash: PropTypes.string,
  trayWizardUrl: PropTypes.string,
  triggerUrl: PropTypes.string,
  socialiveAvailable: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
});
